import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { InnerSection, InnerSectionAttributes } from '../../../app/types/section';

@Component({
    imports: [],
    templateUrl: './inner-section.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export abstract class InnerSectionComponent<SectionType extends InnerSection<InnerSectionAttributes, [], string>> {

  @Input({required: true}) public section!: SectionType;

}
